import Table, { TableBody } from '@ingka/table';
import Text from '@ingka/text';
import { useTranslation } from 'react-i18next';
import Accordion, { AccordionItem } from '@ingka/accordion';
import styles from '../LotteryConfigOverview.module.scss';
import type { LotteryConfigData } from '../types';

export const SimpleSignupInformationTable: React.FC<{
  values: LotteryConfigData;
}> = ({ values: { translation, lottery } }) => {
  const { t } = useTranslation();

  return (
    <div className={styles['sub-accordion']}>
      <Accordion>
        {Object.entries(translation).map(([language, data]) => {
          const { simpleSignup } = data;
          const capitalizedLanguage = language.toUpperCase();
          if (!simpleSignup) {
            return null;
          }
          return (
            <AccordionItem
              title={`${t('form-accordion-simple-signup-translations-language', {
                capitalizedLanguage,
              })}`}
              id={`simple-signup-translations-${capitalizedLanguage}`}
              key={`simple-signup-translations-${capitalizedLanguage}`}
              open={Object.entries(translation).length === 1}
            >
              <Table>
                <TableBody className={styles['tbody']}>
                  <tr>
                    <td className={styles['heading']}>
                      <Text>{t('form-simple-signup-title-label')}</Text>
                    </td>
                    <td>
                      <Text>{simpleSignup.title}</Text>
                    </td>
                  </tr>
                  <tr>
                    <td className={styles['heading']}>
                      <Text>{t('form-simple-signup-body-label')}</Text>
                    </td>
                    <td className={styles['body']}>
                      <Text>{simpleSignup.body}</Text>
                    </td>
                  </tr>
                  <tr>
                    <td className={styles['heading']}>
                      <Text>{t('form-simple-signup-image-label')}</Text>
                    </td>
                    <td>
                      <Text>{simpleSignup.image}</Text>
                    </td>
                  </tr>
                </TableBody>
              </Table>
            </AccordionItem>
          );
        })}
      </Accordion>
    </div>
  );
};
